import { useMemo } from "react";
import useSeo, { SITE_NAME, SITE_ORIGIN } from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/categories";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveFeedSection from "@/pages/home/components/LiveFeedSection";
import CategorySection from "@/pages/home/components/CategorySection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import RankPreviewSection from "@/pages/home/components/RankPreviewSection";
import WhySection from "@/pages/home/components/WhySection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";

const FAQ_DISPLAY = faqs.slice(0, 4);

export default function Home() {
  const highlight = articles.find((item) => item.live) ?? articles[0];
  const liveArticles = articles.filter((item) => item.live).slice(0, 3);
  const featured = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 6);

  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_ORIGIN,
        description: siteInfo.intro,
        email: siteInfo.email,
        foundingDate: siteInfo.since,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_ORIGIN,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE_ORIGIN}/rank?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ_DISPLAY.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
    []
  );

  useSeo({
    title: "吃瓜前线 | 网爆吃瓜现场直播 · 秒删截图 · 第一手爆料实时楼",
    description:
      "吃瓜前线聚合网爆吃瓜现场直播、网爆吃瓜秒删截图与网爆吃瓜实时楼，同步整理群聊记录、现场视频与第一手爆料，帮你一眼看懂今天的热点话题脉络。",
    keywords: "网爆吃瓜,网爆吃瓜现场直播,网爆吃瓜秒删截图,网爆吃瓜第一手爆料,网爆吃瓜实时楼",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <HeroSection highlight={highlight} />
      <LiveFeedSection liveArticles={liveArticles} timelineSource={highlight} />
      <CategorySection />
      <FeaturedSection articles={featured} />
      <RankPreviewSection />
      <WhySection />
      <FaqSection items={FAQ_DISPLAY} moreTo="/contact" />
      <SubscribeSection />
    </>
  );
}